<template>

  <div :id="_uid" class="ui modal" :class="modalSelector">
    <div v-if="receivable" class="ui header">
      Visualizar Parcela {{ receivable.sequence }}
    </div>
    <div v-if="receivable" class="content">
      <div class="ui form">
        <div class="fields">
          <div class="three wide field">
            <label class="form-label">Valor</label>
            R$ {{ $formatCurrency(receivable.value) }}
          </div>
          <div class="four wide field">
            <label class="form-label">Forma de Pagamento</label>
            <i :class="receivable.paymentTypeData.icon"></i>
            {{ receivable.paymentTypeData.description }}
          </div>          
          <div class="three wide field">
            <label class="form-label">Desconto Simavet</label>
            R$ {{ $formatCurrency(receivable.companyDiscount) }}
          </div>
          <div class="three wide field">
            <label class="form-label">Desconto Colaborador</label>
            R$ {{ $formatCurrency(receivable.employeeDiscount) }}
          </div>
          <div class="three wide field">
            <label class="form-label">Valor Recebido</label>
            R$ {{ $formatCurrency(receivable.receivedValue) }}
          </div>
        </div>
        <div class="fields">                              
          <div class="three wide field">
            <label class="form-label">% Cartão</label>
            {{ $formatCurrency(receivable.cardFee) }}
          </div>
          <div class="four wide field">
            <label class="form-label">Taxa Cartão</label>
            R$ {{ $formatCurrency(receivable.cardFeeValue) }}
          </div>
          <div class="three wide field">
            <label class="form-label">Nota Fiscal</label>
            {{ receivable.issuesInvoice ? 'Sim' : 'Não' }}
          </div>
          <div class="three wide field">
            <label class="form-label">% Impostos</label>
            {{ $formatCurrency(receivable.taxes) }}
          </div>
          <div class="three wide field">
            <label class="form-label">Valor Impostos</label>
            {{ $formatCurrency(receivable.taxesValue) }}
          </div>
        </div>
        <div class="fields">                                                          
          <div class="three wide field">
            <label class="form-label">Recebido pelo Colab.</label>
            R$ {{ $formatCurrency(receivable.liquidReceivedValue) }}                
          </div>     
          <div v-if="receivable.receiptDate" class="four wide field">
            <label class="form-label">Data Receb.</label>
            {{ $formatDate(receivable.receiptDate) }}
          </div>
          <div v-if="receivable.receiptRefDate" class="three wide field">
            <label class="form-label">Ref. Receb.</label>
            {{ $formatDate(receivable.receiptRefDate) }}
          </div>
          <div class="four wide field">
            <label class="form-label">Valor a Receber</label>
            {{ $formatCurrency(receivable.invoiceableValue) }}
          </div>
        </div>        
        <div v-if="receivable.user" class="fields">          
          <div class="nine wide field">
            <label class="form-label">Recebido por</label>
            {{ receivable.user.name + ' ' + receivable.user.lastName }}
          </div>            
        </div>        
      </div>
    </div>
    <div class="actions">
      <button class="ui cancel basic button">
        <i class="times icon"></i>
        Fechar
      </button>                  
    </div>
  </div>  

</template>

<script>

  import modalDialog from "@/mixins/modal-dialog"

  export default {
    
    name: "ShowReceivableModal",

    props: ["receivable"],

    mixins: [modalDialog],
  }

</script>